import ApiService from "@/common/api.service";
import {
  FETCH_COMPONENTS,
  FETCH_COMPONENT,
  UPDATE_COMPONENT,
  CREATE_COMPONENT,
  RESET_COMPONENT,
  DELETE_COMPONENT
} from "../actions.type";
import {
  FETCH_COMPONENT_START,
  SET_COMPONENTS,
  SET_COMPONENT
} from "../mutations.type";

const state = {
  components: [],
  componentsCount: 1,
  component: {},
  isLoading: false
};

const getters = {
  componentsCount: state => state.componentsCount,
  components: state => state.components,
  component: state => state.component,
  componentIsLoading: state => state.isLoading
};

const actions = {
  [FETCH_COMPONENTS]({ commit }, [filteringCriteria, search]) {
    commit(FETCH_COMPONENT_START);
    return ApiService.filteredCollection(
      "components",
      filteringCriteria,
      search
    ).then(({ data }) => {
      commit(SET_COMPONENTS, data);
    });
  },
  [FETCH_COMPONENT](context, id) {
    return ApiService.get("components", id).then(({ data }) => {
      context.commit(SET_COMPONENT, data);
    });
  },
  [UPDATE_COMPONENT](context, payload) {
    return ApiService.put(`components/${payload.id}`, payload);
  },
  [CREATE_COMPONENT](context, payload) {
    return ApiService.post("components", payload);
  },
  [RESET_COMPONENT](context) {
    context.commit(SET_COMPONENT, {});
  },
  [DELETE_COMPONENT](context, id) {
    return ApiService.delete("components", id);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_COMPONENT_START](state) {
    state.isLoading = true;
  },
  [SET_COMPONENTS](state, data) {
    state.components = data.items || [];
    state.componentsCount = data.total || 1;
    state.isLoading = false;
  },
  [SET_COMPONENT](state, data) {
    state.component = data;
    state.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
